<template>
  <div class="uploader uploader-image">
    <fields-group :label="label">
      <div v-if="img" class="uploader-image_image">
        <img :src="formatedImgPath" />
        <!--      <v-img :max-width="maxImgWidth" :src="formatedImgPath" />-->
        <div class="uploader-image_image_close" @click="removeImage">
          <v-icon color="red" dense>
            mdi-trash-can-outline
          </v-icon>
        </div>
      </div>
      <v-dialog v-else v-model="dialog" width="500">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            :color="color"
            dark
            v-bind="attrs"
            v-on="on"
          >
            <template>
              <slot />
            </template>
          </v-btn>
        </template>

        <v-card>
          <v-card-title class="headline grey lighten-2">
            Загрузить изображение
          </v-card-title>

          <v-card-text>
            <v-file-input
              v-model="image"
              class="mt-4"
              accept="image/jpg, image/jpeg, image/png, image/gif, image/svg, image/svg+xml, image/webp"
              label="Загрузить изображение"
              outlined
            />
          </v-card-text>

          <v-divider />

          <v-card-actions>
            <v-spacer />
            <v-btn
              class="mr-2"
              :disabled="loading"
              text
              @click="dialog = false"
            >
              Отмена
            </v-btn>
            <v-btn
              color="primary"
              :loading="loading"
              text
              @click="_handleLoader"
            >
              Загрузить
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </fields-group>
    <!--    <label class="uploader-label">{{ label }}</label>-->
  </div>
</template>

<script>
  import FieldsGroup from '@/components/ui/FieldsGroup.vue'

  export default {
    name: 'UploadImage',
    components: { FieldsGroup },
    model: {
      prop: 'img',
      event: 'input',
    },
    props: {
      img: {
        type: String,
        default: '',
      },
      label: {
        type: String,
        default: '',
      },
      color: {
        type: String,
        default: '',
      },
      dialogWidth: {
        type: String,
        default: '500',
      },
      maxImgWidth: {
        type: String,
        default: '500',
      },
      maxImgHeight: {
        type: String,
        default: '300',
      },
    },
    data () {
      return {
        image: [],
        loading: false,
        dialog: false,
        text: '',
      }
    },
    computed: {
      formatedImgPath () {
        const PATH = this.img.match(/collections\/+.*$/g)
        return PATH ? this.storage + PATH[0] : '/not-found.svg'
      },
      storage () {
        return this.$store.getters['api/storage'] + '/images/'
      },
    },
    methods: {
      _handleLoader () {
        this.loading = true

        const formData = new FormData()
        formData.append('image', this.image)
        formData.append('path', '/collections/uploads')

        this.$store.dispatch('upload/uploadImage', formData).then((res) => {
          this.loading = false
          this.dialog = false
          this.text = this.image.name
          this.$emit('input', res.data.image)
        })
      },
      removeImage () {
        this.$emit('input', '')
      },
    },
  }
</script>

<style lang="less">
.uploader {
  width: 100%;

  &-label {
    display: block;
    margin-bottom: 15px;
  }
  &-image {
    &_image {
      width: auto;
      height: auto;
      max-width: 100%;
      display: flex;
      flex: 1 0 auto;
      align-items: center;
      justify-content: center;
      background-color: rgba(239, 239, 239, 0.3);
      border-radius: 4px;
      position: relative;
      overflow: hidden;

      img {
        max-height: 500px;
        max-width: 100%;
      }

      &_close {
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: rgba(255, 255, 255, 0.5);
        border-bottom-left-radius: 4px;
        transform-origin: top right;
        transition: all 0.25s;
        cursor: pointer;
        position: absolute;
        top: 0;
        right: 0;
        z-index: 5;

        &:hover {
          transform: scale(1.2);
        }
      }
    }
  }
}
</style>
